import type { OtpSubFunnelEvent } from '@/utilities/dataLayer/models';
import { pushDataLayer } from '@/utilities/dataLayer/push';

import type { FunnelName, OtpSubStep } from '@/constants/dataLayer';
import { OTP_SUB_FUNNEL } from '@/constants/dataLayer';

type TrackOtpSubFunnelParams = {
    funnelName: FunnelName;
    step: OtpSubStep;
    vehicle?: {
        brand: string;
        model: string;
    };
};

const OTP_STEP_MAP = {
    popup_shown: OTP_SUB_FUNNEL.steps.popupShown,
    code_requested: OTP_SUB_FUNNEL.steps.codeRequested,
    verified: OTP_SUB_FUNNEL.steps.verified
} as const;

export const trackOtpSubFunnel = ({ funnelName, step, vehicle }: TrackOtpSubFunnelParams): void => {
    const otpStep = OTP_STEP_MAP[step];

    const payload: OtpSubFunnelEvent = {
        event: otpStep.event,
        funnel: {
            funnel_name: funnelName,
            sub_funnel_name: OTP_SUB_FUNNEL.name,
            sub_step_number: otpStep.sub_step_number,
            sub_step_name: otpStep.sub_step_name
        },
        ...(vehicle ? { vehicle } : {})
    };

    pushDataLayer(payload);
};
